import ModelViewer from './ModelViewer';

export default ModelViewer;
